<script setup lang="ts">
import { computed } from "vue";
import { useOperationStore } from "@/stores/operation";
import { getFileData } from "@/libs/tools";

const operationStore = useOperationStore();
const op = computed(() => operationStore.operationData);
const files = op.value?.files;

const banner = computed(() => {
  return files ? getFileData(files, "banner_mb") : null;
});

const banner_mobile = computed(() => {
  return files ? getFileData(files, "banner_mobile_mb") : null;
});

// eslint-disable-next-line no-undef
const props = defineProps({
  direction: {
    type: String,
    default: "right",
  },
});
</script>
<template>
  <div class="desktop:absolute desktop:inset-0">
    <div
      :class="`banner_wrapper move-${props.direction}`"
      :style="
        banner
          ? `background-image: url(${banner?.uri})`
          : 'background-image: url(/banner_mb.jpg)'
      "
    />
    <div class="desktop:hidden banner_mobile_wrapper w-full">
      <img :src="banner_mobile?.uri || '/banner_mb.jpg'" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.banner_wrapper {
  @apply h-full hidden desktop:block aspect-square absolute bottom-0 z-10 right-0;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.banner_mobile_wrapper {
  @apply w-full h-auto;
}
</style>
